<template>
	<div class="address">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 mb-3">
					<div class="col-12 pt-3 pb-3 p-md-3 rounded background-white top-slider shadow d-md-flex">
						<div class="p-0 col-12 col-md-3 mt-auto">
							<button class="col-12 col-md-10 btn p-md-2 background-button-template color-white rounded box-purple" @click="addAddress">
								<div class="font-size-11 font-size-sm-9"><i class="fas fa-plus-circle mr-2"></i>Tambah Alamat</div>
							</button>
						</div>
						<div class="form-inline p-0 col-12 col-md-9 m-auto">
							<label class="col-12 p-0 justify-content-start color-mila font-bold mb-2 mt-3 mt-md-0 font-size-sm-10">Filter Berdasarkan</label>
							<div class="input-group col-12 col-md-6 p-0 pr-md-2">
								<select class="col-12 form-control font-size-sm-9 box-purple" v-model="alamat" @change="() => inputan=''">
									<option value="address_receipt_name">Penerima</option>
									<option value="address_name">Label Alamat</option>
									<option value="address_detail">Alamat</option>
								</select>
							</div>
							<div class="input-group col-12 col-md-6 p-0 pr-md-2 mt-2 mt-md-0">
								<input v-model="inputan" :placeholder="placeholderFilter" type="text" class="form-control font-size-sm-8 box-purple" @change="filter" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-md-0 mt-3 mb-3" v-show="listAdress.length == 0">
					<div class="col-12 p-0 pl-3 mt-3 rounded shadow active-address " v-for="(index) in 2" v-bind:key="index">
						<vcl :width='300' :height='48'>
							<rect x="4" y="6" rx="2" ry="2" width="8" height="6" />
							<rect x="15" y="6" rx="2" ry="2" width="40" height="4" />
							<rect x="80" y="6" rx="2" ry="2" width="8" height="6" />
							<rect x="95" y="6" rx="2" ry="2" width="40" height="4" />
							<rect x="224" y="17" rx="2" ry="2" width="30" height="9" />
							<rect x="258" y="17" rx="2" ry="2" width="30" height="9" />
							<rect x="15" y="14" rx="2" ry="2" width="50" height="4" />
							<rect x="95" y="14" rx="2" ry="2" width="50" height="4" />
							<rect x="95" y="14" rx="2" ry="2" width="30" height="4" />
							<rect x="4" y="25" rx="2" ry="2" width="8" height="6" />
							<rect x="15" y="25" rx="2" ry="2" width="50" height="4" />
							<rect x="80" y="25" rx="2" ry="2" width="8" height="6" />
							<rect x="95" y="25" rx="2" ry="2" width="40" height="4" />
							<rect x="15" y="33" rx="2" ry="2" width="35" height="4" />
							<rect x="95" y="33" rx="2" ry="2" width="110" height="4" />
							<rect x="95" y="40" rx="2" ry="2" width="70" height="4" />
						</vcl>
					</div>
				</div>	
				<div class="col-12 p-md-0 mt-3 mb-3" v-if="listAdress == 'error'">
					<div class="col-12 rounded background-white shadow pt-3 pb-3" >
						<div class="text-center">
							<div><img class="img-fluid" src="/assets/icon/no-data-found.svg" alt=""></div>
							<div class="pt-3 color-black">Belum ada alamat tersedia.</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-md-0 mt-3 mb-3" v-else>
					<div class="col-12 p-0 pl-3 mt-3 rounded shadow font-size-sm-9 b-address" :class="value.address_is_default =='1' ? 'active-address' :'' " v-for="(value, index) in listAdress" v-bind:key="index">
						<div class="col-12 pt-3 pb-3">
							<div class="row">
								<div class="col-12 p-0 pl-md-2 pr-md-2 col-md-9">
									<div class="col-12 p-0 d-flex">
										<div class="col-6 p-0 col-md-4 d-flex">
											<div class="col-1 p-0"><i class="fas fa-user mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Penerima</div>
												<div class="col-12 p-0 color-black">{{ value.address_receipt_name }}</div>
											</div>
										</div>
										<div class="col-6 p-0 col-md-8 d-flex">
											<div class="col-1 p-0 text-center"><i class="fas fa-home mr-1 color-mila mt-2"></i></div>
											<div class="col-11 pl-md-1">
												<div class="col-11 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Label Alamat</div>
												<div class="col-11 p-0 color-black">{{ value.address_name}}</div>
											</div>
										</div>
									</div>
									<div class="col-12 p-0 mt-3 mt-md-4 d-md-flex">
										<div class="col-12 p-0 col-md-4 d-flex">
											<div class="col-1 p-0"><i class="fas fa-phone mr-1 color-mila mt-2"></i></div>
											<div class="col-11 pl-1 pl-md-3">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Nomor Handphone</div>
												<div class="col-12 p-0 color-black">{{ value.address_phonenumber }}</div>
											</div>
										</div>
										<div class="col-12 p-0 mt-3 mt-md-0 col-md-8 d-flex">
											<div class="col-1 p-0 text-md-center"><i class="fas fa-map-marker-alt mr-1 color-mila mt-2"></i></div>
											<div class="col-11 pl-1">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Alamat</div>
												<div class="col-12 p-0 color-black" >{{ value.address_detail }}, Kec {{ value.subdistrict_name}}, {{ value.type}} {{ value.city_name}}, {{value.province}}. {{value.address_zipcode}}.</div>
											</div>

										</div>
									</div>
								</div>
								<div class="col-sm-12 p-0 col-md-3 mt-md-0 mt-3 ml-md-0 ml-n3 pt-md-4">
									<div class="col-12 col-md-10 pl-0 pr-3 pr-md-0 ml-3 d-flex flex-wrap pt-md-3">
										<div class="col-6 col-md-12 col-lg-6 pl-0 pr-1 pr-md-0 pr-lg-1">
											<button title="Edit" class="col-12 btn btn-outline-template font-size-15 mr-3 font-size-sm-10 box-purple" @click="detailAddress(value)">
												<i class="fas fa-edit mr-1"></i>Edit
											</button>
										</div>
										<div class="col-6 col-md-12 col-lg-6 pr-0 pl-1 pl-md-0 pl-lg-1 pt-md-2 pt-lg-0">
											<button title="Hapus" :disabled="value.address_is_default == 1" class="col-12 btn btn-outline-danger font-size-15 font-size-sm-10" @click="()=> {$refs.delete.modalShow(); id = value.address_id;}">
												<i class="fas fa-trash-alt mr-1"></i>Hapus
											</button>
										</div>
									</div>
									<div class="col-12 col-md-10 pl-0 p-md-0 order-1 mt-2 ml-3" id="_buttonAlamat2">
										<button v-if="value.address_is_default == '0'" class="col-12 btn background-button-template font-size-sm-9 color-white box-purple" @click="()=> { id = value.address_id; $refs.defaultAddress.modalShow(); }">Jadikan Utama</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<v-modal ref="tambahAlamat">
			<template v-slot:header>
				<div class="modal-header d-block">
					<h4 class="color-black text-center">Tambah Alamat</h4>
				</div>
			</template>
			<div slot="body">
				<form class="mt-2">
					<div class="form-inline">
						<input @focus="() => alert.receipt_name=''" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 pl-2 box-purple" v-model="insert.receipt_name" type="text" placeholder="Nama Penerima" />
						<Alert v-if="alert.receipt_name" class="col-12 offset-md-2 pl-0 col-md-8 font-size-sm-10" empty :content="alert.receipt_name"></Alert>
					</div>
					<div class="form-inline mt-3">
						<input @focus="() => alert.name=''" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 pl-2 box-purple" v-model="insert.name" type="text" placeholder="Label Alamat, Contoh: Rumah" />
						<Alert v-if="alert.name" class="col-12 offset-md-2 pl-0 col-md-8 font-size-sm-10" empty :content="alert.name"></Alert>
					</div>
					<div class="form-inline mt-3">
						<input @focus="() => alert.phonenumber=''" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple pl-2 f-lato" v-model="insert.phonenumber" type="text" placeholder="Nomor Handphone" maxlength="12" />
						<Alert v-if="alert.phonenumber" class="col-12 offset-md-2 pl-0 col-md-8 font-size-sm-10" empty :content="alert.phonenumber"></Alert>
					</div>
					<div class="form-inline mt-3">
						<v-select label="province" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :reduce="provinces => provinces.province_id" :options="provinces" v-model="insert.province_id" placeholder="Pilih Provinsi" @input="changeProvince">
							<template #selected-option="{ province }">
								<div style="display: flex; align-items: baseline;">
									<span>Provinsi</span>
									<span style="margin-left: .4rem;">{{ province }}</span>
								</div>
							</template>
							<template v-slot:option="option">
								Provinsi {{ option.province }}
							</template>
							<template v-slot:no-options="{ search, searching }">
								<template v-if="searching">
									Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
								</template>
								<em style="opacity: 0.5;" v-else>Ketik untuk mencari Provinsi</em>
							</template>
						</v-select>
						<Alert v-if="alert.province_id" class="col-12 offset-md-2 pl-0 col-md-8 font-size-sm-10" empty :content="alert.province_id"></Alert>
					</div>
					<div class="form-inline mt-3">
						<v-select label="city_name" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :reduce="city => city.city_id" :options="city" v-model="insert.city_id" placeholder="Pilih Kabupaten/Kota" @input="changeCity">
							<template #selected-option="{ type, city_name }">
								<div style="display: flex; align-items: baseline;">
									<span>{{ type }}</span>
									<span style="margin-left: .4rem;">{{ city_name }}</span>
								</div>
							</template>
							<template v-slot:option="option">
								{{ option.type }} {{ option.city_name }}
							</template>
							<template v-slot:no-options="{ search, searching }">
								<template v-if="searching">
									Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
								</template>
								<em style="opacity: 0.5;" v-else>Silahkan memilih Provinsi terlebih dahulu</em>
							</template>
						</v-select>
						<Alert v-if="alert.city_id" class="col-12 offset-md-2 pl-0 col-md-8 font-size-sm-10" empty :content="alert.city_id"></Alert>
					</div>
					<div class="form-inline mt-3">
						<v-select label="subdistrict_name" class="col-12 offset-md-2 col-md-8 font-size-sm-10 pl-0 pr-0" :options="districts" v-model="insert.district_id" placeholder="Pilih Kecamatan" @input="() => {changeDistrict(); alert.district_id='';}">
							<template v-slot:no-options="{ search, searching }">
								<template v-if="searching">
									Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
								</template>
								<em style="opacity: 0.5;" v-else>Silahkan memilih Kabupaten/Kota terlebih dahulu</em>
							</template>
						</v-select>
						<!-- <select @focus="() => alert.district_id=''" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" v-model="insert.district_id" name="district_id" @change="changeDistrict()">
							<option value="" disabled selected hidden>Kecamatan</option>
							<option v-for="(district, index) in districts" :key="index" :value="district">Kecamatan {{district.subdistrict_name}}</option>
						</select> -->
						<Alert v-if="alert.district_id" class="col-12 offset-md-2 pl-0 col-md-8 font-size-sm-10" empty :content="alert.district_id"></Alert>
					</div>
					<div class="form-inline mt-3">
						<input @focus="() => alert.zipcode=''" type="text" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple f-lato" v-model="insert.zipcode" name="postal_code" placeholder="Kodepos">
						<Alert v-if="alert.zipcode" class="col-12 offset-md-2 pl-0 col-md-8 font-size-sm-10" empty :content="alert.zipcode"></Alert>
					</div>
					<div class="form-inline mt-3 mb-3">
						<textarea @focus="() => alert.detail=''" class="form-control col-12 offset-md-2 col-md-8 font-size-sm-9 box-purple" v-model="insert.detail" rows="3" placeholder="Alamat" ></textarea>
						<Alert v-if="alert.detail" class="col-12 offset-md-2 pl-0 col-md-8 font-size-sm-10" empty :content="alert.detail"></Alert>
					</div>
				</form>
			</div>
			<div slot="footer">
				<div class="modal-footer justify-content-center">
					<div class="form-inline">
						<button class="btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" type="button" @click="()=> {$refs.tambahAlamat.modalHide(); resetInsert()}">
							<i class="fa fa-times mr-3"></i>Batal
						</button>
						<button class="btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple" type="button" @click="save">
							<i class="fa fa-save mr-3"></i>Simpan
						</button>
					</div>
				</div>
			</div>
		</v-modal>

		<v-modal ref="delete" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<div slot="body" class="col-12 mb-3 d-md-flex mt-n3 mt-md-0">
				<div class="col-5 m-auto pt-3">
					<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
				</div>
				<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
					<div class="font-bold font-size-sm-12">Hapus Alamat</div>
					<div class="font-size-sm-11 pt-2">Apakah Anda yakin untuk menghapus data alamat?</div>
				</div>
			</div>
			<div slot="footer">
				<div class="modal-footer justify-content-center justify-content-md-end">
					<button class="col-6 col-md-3 btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" type="button" @click="()=> {$refs.delete.modalHide();}">
						<i class="fa fa-times mr-1"></i>Batal
					</button>
					<button class="col-6 col-md-4 btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple" type="button" @click="konfirmDelete">
						<i class="fa fa-check mr-1"></i>Saya yakin
					</button>
				</div>
			</div>
		</v-modal>

		<v-modal ref="defaultAddress" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<div slot="body" class="col-12 mb-3 d-md-flex">
				<div class="col-5 m-auto pt-md-3">
					<img class="img-fluid" src="/assets/icon/smile-woman.svg">
				</div>
				<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
					<div class="font-bold font-size-sm-12">Konfirmasi Alamat Utama</div>
					<div class="font-size-sm-11 pt-2">Apakah Anda yakin akan menjadikan Alamat Utama?</div>
				</div>
			</div>
			<div slot="footer">
				<div class="modal-footer justify-content-center justify-content-md-end">
					<button class="col-6 col-md-3 btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" type="button" @click="()=> {$refs.defaultAddress.modalHide();}">
						<i class="fa fa-times mr-1"></i>Batal
					</button>
					<button class="col-6 col-md-4 btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple" type="button" @click="setUtama">
						<i class="fa fa-check mr-1"></i>Saya Yakin
					</button>
				</div>
			</div>
		</v-modal>
	</div>
</template>

<script>
import Alert from '@/components/Alert';
import VModal from '@/components/VModal';
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
	name: 'Address',
	components: {
		Alert,
		VModal,
	},
	data: () =>({
		id: '',
		alamat: 'address_receipt_name',
		inputan:'',
		insert: {
			id: '',
			name: '',
			receipt_name: '',
			phonenumber: '',
			as: '1',
			detail: '',
			zipcode: '',
			province_id: '',
			city_id: '',
			district_id: '',
		},
		alert : {
			name: '',
			receipt_name: '',
			phonenumber:'',
			zipcode: '',
			province_id: '',
			city_id: '',
			district_id: '',
			detail: '',
		},
	}),
	computed:{
		...mapState('address', ['listAdress', 'selectedAddress', 'provinces', 'city', 'districts']),

		placeholderFilter() {
			if (this.alamat == "address_detail") {
				return "Masukan Alamat Penerima"
			} else if(this.alamat == "address_receipt_name") {
				return "Masukan Nama Penerima"
			} else if(this.alamat == "address_name") {
				return "Masukan Label Alamat Penerima"
			} else {
				return "-"
			}
		}
	},
	methods: {
		...mapMutations('address', ['reset']),
		...mapActions('address', ['getAddressList', 'selectAddress', 'getProvinces', 'getCity', 'getDistrict', 'submit', 'update', 'updateUtama', 'deleteAddress']),

		changeProvince() {
			this.getCity(this.insert.province_id) 
			this.alert.province_id=''
			this.insert.city_id=''
			this.insert.district_id=''
			this.insert.zipcode=''
		},
		changeCity() {
			this.getDistrict(this.insert.city_id)
			this.alert.city_id=''
			this.insert.district_id=''
			this.insert.zipcode=''
		},
		filter(){
			let params = {
				'filter[0][field]': this.alamat,
				'filter[0][type]': 'string',
				'filter[0][value]': this.inputan,
				'filter[0][comparison]': 'like',
				sort: 'address_id',
				dir: 'DESC'
			}
			this.getAddressList(params);
		},
		konfirmDefault(){

		},
		konfirmDelete(){
			this.deleteAddress(this.id).then(() => {
				this.$refs.delete.modalHide();
			})
		},
		addAddress(){
			this.$refs.tambahAlamat.modalShow();
			this.id=''
		},
		detailAddress(value){
			this.getCity(value.address_province_id).then(() => {
				this.insert.city_id = value.address_city_id
			})
			this.getDistrict(value.address_city_id).then(() => {
				this.insert.district_id = {
					subdistrict_id: value.address_district_id,
					subdistrict_name: value.subdistrict_name,
					city_id: value.address_city_id,
					city_name: value.city_name,
					type: value.type,
					postal_code: value.address_zipcode,
					province_id: value.address_province_id,
					province: value.province,
				}
			})
			this.id = value.address_id;
			this.insert.as = value.address_is_default;
			this.insert.name = value.address_name
			this.insert.receipt_name = value.address_receipt_name
			this.insert.phonenumber = value.address_phonenumber
			this.insert.detail = value.address_detail
			this.insert.province_id = value.address_province_id
			this.insert.zipcode = value.address_zipcode
			this.$refs.tambahAlamat.modalShow();
		},
		changeDistrict() {
			this.insert.zipcode = this.insert.district_id.postal_code
		},
		save(){
			if (!this.insert.receipt_name) {
				this.alert.receipt_name = 'Nama Penerima belum anda isi'
			}
			if (!this.insert.name) {
				this.alert.name = 'Label Alamat belum anda isi'
			}
			if (!this.insert.phonenumber) {
				this.alert.phonenumber = 'Nomor Telepon belum anda isi'
			}
			if (!this.insert.province_id) {
				this.alert.province_id = 'Provinsi belum anda isi'
			}
			if (!this.insert.city_id) {
				this.alert.city_id = 'Kota belum anda isi'
			}
			if (!this.insert.district_id) {
				this.alert.district_id = 'Kecamatan belum anda isi'
			}
			// if (!this.insert.zipcode) {
			// 	this.alert.zipcode = 'Kode Pos belum anda isi'
			// } else {
			// 	this.alert.zipcode = ''
			// }
			if (!this.insert.detail) {
				this.alert.detail = 'Alamat belum anda isi'
			} else if (this.insert.detail.length < 5) {
				this.alert.detail = 'Alamat minimal 5 karakter'
			}
			if (this.insert.receipt_name && this.insert.name && this.insert.phonenumber && this.insert.province_id && this.insert.city_id && this.insert.district_id && 
			// this.insert.zipcode && 
			this.insert.detail){
				this.insert.district_id = this.insert.district_id.subdistrict_id
				if(!this.id){
					this.submit(this.insert).then(() => {
						this.$refs.tambahAlamat.modalHide();
						this.resetInsert()
					});
				} else {
					this.insert['id'] = this.id
					this.update(this.insert).then(() => {
						this.$refs.tambahAlamat.modalHide();
						this.resetInsert()
					});
				}

			}

		},
		resetInsert(){
			this.insert = {
				name: '',
				receipt_name: '',
				phonenumber: '',
				as: '1',
				detail: '',
				zipcode: '',
				province_id: '',
				city_id: '',
				district_id: '',
			}
		},
		setUtama(){
			this.updateUtama(this.id).then(() => {
				this.$refs.defaultAddress.modalHide();
			})
		}
	},
	created(){
		this.getAddressList();
		this.getProvinces();
	},
}
</script>

<style scoped>
.b-address {
	border: 1px solid #f7f7f7;
	border-left-width: 10px;
}
.active-address {
	border: 1px solid #7C1CC6 !important;
	border-left-width: 10px !important;
}
</style>